import { Fixtuur } from '@fixtuur/backpack';
import * as O from 'fp-ts/Option';
import { pipe } from 'fp-ts/function';
import * as Hooks from 'preact/hooks';
import { useSelector } from '../../../store/redux';
import * as Selectors from '../../../store/selectors';

/** Return the latest current selections, only updating it when something actually changes */
export const useCurrentSelections = () => {
    const productSelections = useSelector(Selectors.Selections.productSelections);
    const groupingCodeSelections = useSelector(Selectors.Selections.groupingCodeSelections);
    const buildPropertySelections = useSelector(Selectors.Selections.buildPropertySelections);

    const currentSelections = Hooks.useMemo(() => {
        return pipe(
            O.Do,
            O.bind('productSelections', () => O.fromNullable(productSelections)),
            O.bind('groupingCodeSelections', () => O.fromNullable(groupingCodeSelections)),
            O.bind('buildPropertySelections', () => O.fromNullable(buildPropertySelections)),
            O.map(({ productSelections, groupingCodeSelections, buildPropertySelections }) =>
                Fixtuur.Configuration.Selections.concat(
                    Fixtuur.Configuration.Selections.concat(
                        productSelections,
                        groupingCodeSelections,
                    ),
                    buildPropertySelections,
                ),
            ),
            O.toUndefined,
        );
    }, [productSelections, groupingCodeSelections, buildPropertySelections]);

    return currentSelections;
};
